import Button from '@ergeon/core-components/exports/Button.ts';

import { DefaultError as BaseDefaultError, ErrorProps } from '@/components/Error';

interface DefaultError extends ErrorProps {
  onClick?(): void;
}

export function DefaultError({ onClick, ...errorProps }: DefaultError) {
  return (
    <BaseDefaultError {...errorProps}>
      {Boolean(onClick) &&
        <Button flavor="primary" onClick={onClick}>
          Retry
        </Button>
      }
    </BaseDefaultError>
  );
}
